"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Job_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Job = exports.JobEventsEnum = void 0;
const typeorm_1 = require("typeorm");
const job_product_1 = require("./job_product");
const job_service_1 = require("./job-service");
const rejected_job_1 = require("./rejected-job");
const account_1 = require("./account");
const base_job_1 = require("./base-job");
const comment_1 = require("./comment");
const job_prepayment_reminder_1 = require("./job-prepayment-reminder");
const opportunity_1 = require("./opportunity");
const email_1 = require("./email");
const job_days_since_change_1 = require("./job-days-since-change");
const materialized_job_types_1 = require("./materialized/materialized-job-types");
const wallbox_install_priority_for_job_1 = require("./wallbox-install-priority-for-job");
const data_ui_1 = require("../data-ui");
const contact_profile_enum_1 = require("./contact-profile-enum");
const layouts_1 = require("../data-ui/layouts");
const price_calculations_view_1 = require("./price-calculations-view");
const job_media_file_1 = require("./job-media-file");
const events_1 = require("../events");
const job_state_1 = require("./job-state");
const job_availability_1 = require("./job-availability");
const job_contact_person_1 = require("./job-contact-person");
const custom_services_1 = require("./custom-services");
const job_cancellation_1 = require("./job-cancellation");
const job_properties_1 = require("./job-properties");
const contact_1 = require("./contact");
const job_selection_1 = require("./job-selection");
const ticket_1 = require("./ticket");
const order_form_questions_1 = require("./order-form-questions");
var JobEventsEnum;
(function (JobEventsEnum) {
    JobEventsEnum["STATE_CHANGE"] = "state_change";
})(JobEventsEnum = exports.JobEventsEnum || (exports.JobEventsEnum = {}));
let Job = Job_1 = class Job extends base_job_1.BaseJob {
};
Job.EVENTS = (0, events_1.makeEventsForClass)(Job_1, JobEventsEnum);
Job.SFID_PREFIX = 'a1r';
Job.NAME_PREFIX = 'O';
Job.NAME_LENGTH = 10;
__decorate([
    (0, typeorm_1.OneToMany)(() => rejected_job_1.RejectedJob, (rejectedJobs) => rejectedJobs.job),
    __metadata("design:type", Array)
], Job.prototype, "rejectedJobsAPI", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_product_1.JobProduct, (jobProduct) => jobProduct.job),
    __metadata("design:type", Array)
], Job.prototype, "products", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_service_1.JobService, (jobService) => jobService.job),
    __metadata("design:type", Array)
], Job.prototype, "services", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_product_1.JobProduct, (jobProduct) => jobProduct.job),
    __metadata("design:type", Array)
], Job.prototype, "additionalItems", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => custom_services_1.CustomService, (customServices) => customServices.job),
    __metadata("design:type", Array)
], Job.prototype, "customServices", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_selection_1.JobSelection, (selection) => selection.job),
    __metadata("design:type", Array)
], Job.prototype, "selections", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => account_1.Account, (brand) => brand.brandJobs),
    (0, typeorm_1.JoinColumn)({
        name: 'brand__c',
    }),
    __metadata("design:type", account_1.Account)
], Job.prototype, "brand", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => account_1.Account, (brand) => brand.brandJobs),
    (0, typeorm_1.JoinColumn)({
        name: 'brand2__c',
    }),
    __metadata("design:type", account_1.Account)
], Job.prototype, "brand2", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => account_1.Account, (partner) => partner.partnerJobs),
    (0, typeorm_1.JoinColumn)({
        name: 'professional__c',
    }),
    __metadata("design:type", account_1.Account)
], Job.prototype, "partner", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => account_1.Account, (partner) => partner.customerJobs),
    (0, typeorm_1.JoinColumn)({
        name: 'customer__c',
    }),
    __metadata("design:type", account_1.Account)
], Job.prototype, "customer", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => account_1.Account),
    (0, typeorm_1.JoinColumn)({
        name: 'customer_second__c',
    }),
    __metadata("design:type", account_1.Account)
], Job.prototype, "customerSecond", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => account_1.Account),
    (0, typeorm_1.JoinColumn)({
        name: 'affiliate__c',
    }),
    __metadata("design:type", account_1.Account)
], Job.prototype, "affiliate", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        name: 'affiliate__c',
        length: 18,
    }),
    __metadata("design:type", String)
], Job.prototype, "affiliateAccountId", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true, showInline: true }),
    (0, typeorm_1.OneToOne)(() => materialized_job_types_1.MaterializedJobTypes, (jobTypes) => jobTypes.job),
    __metadata("design:type", materialized_job_types_1.MaterializedJobTypes)
], Job.prototype, "jobTypes", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToOne)(() => job_prepayment_reminder_1.JobPrepaymentReminders, (jobPrepaymentReminders) => jobPrepaymentReminders.id),
    __metadata("design:type", job_prepayment_reminder_1.JobPrepaymentReminders)
], Job.prototype, "jobPrepaymentReminders", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => job_contact_person_1.JobContactPerson, (jobContactPerson) => jobContactPerson.jobs),
    (0, typeorm_1.JoinColumn)({ name: 'job_contact_person' }),
    __metadata("design:type", job_contact_person_1.JobContactPerson)
], Job.prototype, "jobContactPerson", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => opportunity_1.Opportunity, (opportunity) => opportunity.jobs),
    (0, typeorm_1.JoinColumn)({
        name: 'opportunity__c',
    }),
    __metadata("design:type", opportunity_1.Opportunity)
], Job.prototype, "opportunity", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.ManyToMany)(() => email_1.Email, (email) => email.jobs),
    __metadata("design:type", Array)
], Job.prototype, "emails", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => comment_1.Comment, (comment) => comment.job),
    __metadata("design:type", Array)
], Job.prototype, "comments", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => job_state_1.JobState, (state) => state.job),
    __metadata("design:type", Array)
], Job.prototype, "states", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => job_availability_1.JobAvailability, (availabilityDate) => availabilityDate.job),
    __metadata("design:type", Array)
], Job.prototype, "availabilityDates", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToOne)(() => job_days_since_change_1.JobDaysSinceChange, (jobDaysSinceChange) => jobDaysSinceChange.job),
    __metadata("design:type", job_days_since_change_1.JobDaysSinceChange)
], Job.prototype, "jobDaysSinceChange", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => wallbox_install_priority_for_job_1.WallboxInstallPriorityForJob, (jobWallboxInstallPriority) => jobWallboxInstallPriority.job),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", wallbox_install_priority_for_job_1.WallboxInstallPriorityForJob)
], Job.prototype, "jobWallboxInstallPriority", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => price_calculations_view_1.PriceCalculationsView, (priceCalculationsView) => priceCalculationsView.job),
    __metadata("design:type", price_calculations_view_1.PriceCalculationsView)
], Job.prototype, "priceCalculationsView", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => job_media_file_1.JobMediaFile, (file) => file.job),
    __metadata("design:type", Array)
], Job.prototype, "files", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => job_cancellation_1.JobCancellation, (cancellation) => cancellation.job),
    __metadata("design:type", Array)
], Job.prototype, "cancellations", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Own Installer' }),
    (0, typeorm_1.Column)('boolean', {
        default: false,
    }),
    __metadata("design:type", Boolean)
], Job.prototype, "ownInstaller", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
    }),
    __metadata("design:type", Boolean)
], Job.prototype, "isReclamation", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
    }),
    __metadata("design:type", Boolean)
], Job.prototype, "paymentReminderBlocker", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Job Created Automatically', readOnly: true }),
    (0, typeorm_1.Column)('boolean', {
        name: 'auto_created_job',
        default: false,
    }),
    __metadata("design:type", Boolean)
], Job.prototype, "autoCreatedJob", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Job Closed Automatically', readOnly: true }),
    (0, typeorm_1.Column)('boolean', {
        name: 'next_step_job',
        default: false,
    }),
    __metadata("design:type", Boolean)
], Job.prototype, "nextStepJob", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => job_properties_1.JobProperties, (jobProperties) => jobProperties.job, {
        nullable: true,
    }),
    __metadata("design:type", job_properties_1.JobProperties)
], Job.prototype, "properties", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => contact_1.Contact, (contact) => contact.installedJobs, {
        onDelete: 'SET NULL',
        onUpdate: 'CASCADE',
    }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", contact_1.Contact)
], Job.prototype, "partnerInstallerContact", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => ticket_1.Ticket, (ticket) => ticket.jobs),
    __metadata("design:type", Array)
], Job.prototype, "tickets", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => order_form_questions_1.Submission, (submission) => submission.job),
    __metadata("design:type", Array)
], Job.prototype, "submission", void 0);
Job = Job_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Job',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('job__c', { schema: 'public', synchronize: true })
], Job);
exports.Job = Job;
//# sourceMappingURL=job.js.map